(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["py-bak-20261022-variant-main-picker"] && !Shopify.designMode) return;
  try {
    /* Perfect Yarns: "Show all colors" toggle for photo tiles.
     Only toggles a CSS class; it never touches inputs, variants or the cart.
     The open state is re-applied after Horizon re-renders the picker. */
  (function () {
    if (window.__pyVariantTiles) return;
    window.__pyVariantTiles = true;

    var expanded = new Set();

    function keyOf(fieldset) {
      var picker = fieldset.closest('variant-picker');
      return (picker ? picker.dataset.productId : '') + '|' + (fieldset.dataset.pyOption || '');
    }

    function apply() {
      document.querySelectorAll('.variant-option--tiles[data-py-option]').forEach(function (fieldset) {
        var isOpen = expanded.has(keyOf(fieldset));
        fieldset.classList.toggle('is-expanded', isOpen);
        var button = fieldset.querySelector('[data-py-tiles-toggle]');
        if (button) button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-py-tiles-toggle]');
      if (!button) return;
      var fieldset = button.closest('.variant-option--tiles');
      if (!fieldset) return;
      var key = keyOf(fieldset);
      if (expanded.has(key)) {
        expanded.delete(key);
      } else {
        expanded.add(key);
      }
      apply();
    });

    var queued = false;
    new MutationObserver(function () {
      if (queued || expanded.size === 0) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        apply();
      });
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    /* Perfect Yarns: "Show all colors" toggle for photo tiles.
     Only toggles a CSS class; it never touches inputs, variants or the cart.
     The open state is re-applied after Horizon re-renders the picker. */
  (function () {
    if (window.__pyVariantTiles) return;
    window.__pyVariantTiles = true;

    var expanded = new Set();

    function keyOf(fieldset) {
      var picker = fieldset.closest('variant-picker');
      return (picker ? picker.dataset.productId : '') + '|' + (fieldset.dataset.pyOption || '');
    }

    function apply() {
      document.querySelectorAll('.variant-option--tiles[data-py-option]').forEach(function (fieldset) {
        var isOpen = expanded.has(keyOf(fieldset));
        fieldset.classList.toggle('is-expanded', isOpen);
        var button = fieldset.querySelector('[data-py-tiles-toggle]');
        if (button) button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-py-tiles-toggle]');
      if (!button) return;
      var fieldset = button.closest('.variant-option--tiles');
      if (!fieldset) return;
      var key = keyOf(fieldset);
      if (expanded.has(key)) {
        expanded.delete(key);
      } else {
        expanded.add(key);
      }
      apply();
    });

    var queued = false;
    new MutationObserver(function () {
      if (queued || expanded.size === 0) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        apply();
      });
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
